import { useState } from "react";
import { useSessao } from "@/sessao/useSessao";
import { useCriarSistema } from "@/api/consultas";
import { textoDoErro } from "@/api/problema";
import { Campo } from "@/componentes/Campo";
import { ModalDeCadastro } from "@/componentes/ModalDeCadastro";

/*
 * Cadastro de aplicação integradora — change 20d.
 *
 * O webhook é OPCIONAL aqui, e a dica do campo diz por quê: o caso comum é o
 * cliente ainda não ter subido o endpoint quando pede a integração. Exigi-lo na
 * criação faria alguém inventar um endereço para poder continuar — e um
 * endereço inventado é pior do que nenhum, porque a entrega passa a falhar
 * contra ele em silêncio.
 */
export function NovoSistema({ aberto, aoFechar }: { aberto: boolean; aoFechar: () => void }) {
  const { cliente } = useSessao();
  const criar = useCriarSistema(cliente);

  const [nome, setNome] = useState("");
  const [documento, setDocumento] = useState("");
  const [webhook, setWebhook] = useState("");
  const [segredoRef, setSegredoRef] = useState("");

  function enviar() {
    criar.mutate(
      {
        nome,
        documento,
        ...(webhook.trim() !== "" && { webhook_url: webhook }),
        ...(segredoRef.trim() !== "" && { webhook_secret_ref: segredoRef }),
      },
      {
        onSuccess: () => {
          setNome("");
          setDocumento("");
          setWebhook("");
          setSegredoRef("");
          aoFechar();
        },
      },
    );
  }

  return (
    <ModalDeCadastro
      aberto={aberto}
      aoFechar={aoFechar}
      titulo="Nova aplicação"
      aoEnviar={enviar}
      enviando={criar.isPending}
      erro={criar.error ? textoDoErro(criar.error) : undefined}
    >
      <Campo
        rotulo="Nome"
        value={nome}
        onChange={(evento) => setNome(evento.target.value)}
        placeholder="ERP do cliente"
        autoFocus
        required
      />

      <Campo
        rotulo="CNPJ ou CPF"
        value={documento}
        onChange={(evento) => setDocumento(evento.target.value)}
        placeholder="31.000.000/0001-15"
        required
      />

      <Campo
        rotulo="Webhook"
        type="url"
        value={webhook}
        onChange={(evento) => setWebhook(evento.target.value)}
        placeholder="https://cliente.exemplo.com/webhook"
        // Endereço em rede interna é recusado pela API — a mesma guarda que a
        // entrega aplica. Dizer isso aqui evita a viagem de descobrir no envio.
        dica="Opcional. Endereço público: rede interna é recusada."
      />

      <Campo
        rotulo="Referência do segredo"
        value={segredoRef}
        onChange={(evento) => setSegredoRef(evento.target.value)}
        placeholder="webhook/cliente-x"
        // O painel nunca vê o segredo: ele mora no cofre, e o banco de negócio
        // guarda só o nome pelo qual a entrega o procura.
        dica="O nome do segredo no cofre, nunca o segredo."
      />
    </ModalDeCadastro>
  );
}
